import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            de: {
                translations: {
                    'page.error.headline': '404',
                    'page.error.copy': `
                        Huch – sieht ganz so aus, als hättest du dich vertaucht! 
                     
                        Hier unten existiert so gut wie nichts mehr. Noch nicht mal die gesuchte Seite.
                    `,
                }
            }
        },
        fallbackLng: 'de',
        lng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;

